<script setup lang="ts">
import { isString } from "lodash-es";
import { computed } from "vue";

interface Props {
  name: string;
  className?: string;
  size?: string | number;
}
const props = withDefaults(defineProps<Props>(), {
  name: "",
  className: "",
  size: ""
});

const iconName = computed(() => `#icon-${props.name}`);
const svgClass = computed(() => {
  if (props.className) {
    return "y-icon " + props.className;
  } else {
    return "y-icon";
  }
});

const style = computed(() => {
  return {
    fontSize: isString(props.size) ? props.size : props.size + "px"
  };
});
</script>

<template>
  <svg
    :class="svgClass"
    :style="{ ...style }"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<style scoped>
.y-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: unset;
}
</style>
